// Values are rendered as `data-tour="<value>"` on the anchored element — every
// product tour step spotlights one of these, never a CSS class or a data-cy hook.
export enum ProductTourAnchorType {
  // Main tour (sidebar)
  WorkspaceSwitcher = 'workspace-switcher',
  SpaceSwitcher = 'space-switcher',
  CreateResourceButton = 'create-resource-button',
  ResourcesList = 'resources-list',
  QuickNavigationSearch = 'quick-navigation-search',
  QuickNavigationTalk = 'quick-navigation-talk',
  NotificationsButton = 'notifications-button',
  UserProfile = 'user-profile',

  // Database tour (view header + table)
  DatabaseViewTabs = 'database-view-tabs',
  DatabaseAddView = 'database-add-view',
  DatabaseGroupBy = 'database-group-by',
  DatabaseSearch = 'database-search',
  DatabaseFilters = 'database-filters',
  DatabasePeopleFilter = 'database-people-filter',
  DatabaseSort = 'database-sort',
  DatabaseHiddenProperties = 'database-hidden-properties',
  DatabaseAddItem = 'database-add-item',
  DatabaseAddItemInGroup = 'database-add-item-in-group',
  DatabaseAddProperty = 'database-add-property',
  DatabaseTable = 'database-table',

  // Document tour (editor)
  DocumentTitle = 'document-title',
  DocumentEditor = 'document-editor',
  DocumentStatusChip = 'document-status-chip',
  DocumentCommentsToggle = 'document-comments-toggle',
}
